var MenuHeader = require("./MenuHeader");

function ColumnLayoutContainer(navManager, element, displayMode, headerParent) {
    var self = this;
    var $content = element;

    var $parentPage = headerParent || $content.closest("[data-role=page]");

    var header = new MenuHeader();
    $parentPage.append(header.getContent());
    header.hide();

    var $firstColumn = $("<div>", {"class" : "scrollContent column first"});
    $firstColumn.on("scrollstop", function(event) {
        $(document).trigger("columnScrollStop", [event.target, currentViews[0]]);
    });
    $content.append($firstColumn);

    var $secondColumn = $("<div>", {"class" : "scrollContent column second"});
    $secondColumn.on("scrollstop", function(event) {
        if (currentViews.length == columns.length) {
            $(document).trigger("columnScrollStop", [event.target, currentViews.last()]);
        }
    });
    $content.append($secondColumn);

    var columns = [$firstColumn, $secondColumn];

    var currentViews = [];
    var numColumns = 0;

    /**
     * @param width {number} The horizontal space available (in pixels) that the columns should fill
     * @param height {number} The vertical space available (in pixels) that the columns should fill
     */
    function manageColumns(width, height) {
        var columnsToShow = (width > 740) ? 2 : 1;

        if (numColumns !== columnsToShow) {
            numColumns = columnsToShow;

            if (currentViews.length > 0) {
                self.setView(currentViews.last());
            }

            for (var c = 0; c < columns.length; c++) {
                columns[c].toggle(c < numColumns);
            }
        }

        header.setNumColumns(columnsToShow);

        // Resize the visible views
        height -= header.getContent().outerHeight();

        for (var i = 0; i < columns.length; i++) {
            columns[i].height(height);
        }
    }

    /**
     * @param view {AbstractView}
     */
    this.setView = function(view) {
        if (currentViews.length > 0) {
            currentViews.forEach(function(view) {
                view.hide();
            });
        }

        // Detach the existing views from the columns
        columns.forEach(function(column) {
            column.children().detach();
        });

        // Add the view to the list of current views
        currentViews = [view];

        if (numColumns > 1) {
            // Check if the previous view in the navManager's history is something we should also be showing
            var navHistory = navManager.getHistory();

            if (navHistory.length > 1) {
                var prevView = navHistory[navHistory.length - 2];

                if (view.getDisplayMode && view.getDisplayMode() === "menu") {
                    if (!(prevView.getChildrenHashNames && prevView.getChildrenHashNames())) {
                        // The previous view doesn't have children so we have either got to the root of the menu
                        // (so we only want to display something in the left hand column) or the user has selected a
                        // sibling of the parent.
                        prevView = navHistory[navHistory.length - 1];

                        // Check that this new previous view is a parent of view
                        if (prevView.getChildrenHashNames && prevView.getChildrenHashNames() &&
                            prevView.getChildrenHashNames().indexOf(view.getHashName()) < 0) {
                            // Previous view is not a parent of view, so we are at the root of the menu. Set the prevView
                            // back to the original prevView which will not be unshifted into currentViews as it has a
                            // different displayMode.
                            prevView = navHistory[navHistory.length - 2];
                        }
                    }
                }

                if (prevView && prevView.getDisplayMode && prevView.getDisplayMode() === displayMode) {
                    currentViews.unshift(prevView);
                }
            }
        }

        var headerConfigs = [];

        for (var i = 0; i < currentViews.length; i++) {
            columns[i].append(currentViews[i].getContent());
            currentViews[i].show();

            // Get header config from views and update header accordingly
            headerConfigs.push(currentViews[i].getHeaderConfiguration());
        }

        // Put in some extra empty headers if we aren't filling all the columns
        for (var j = currentViews.length; j < columns.length; j++) {
            headerConfigs.push({title : "", disableBackButton : true});
        }

        header.configure(headerConfigs);
    };

    /**
     * @param view {AbstractView} The view to be added to the container
     */
    this.addView = function(view) {
        var viewContent = view.getContent();
        $content.append(viewContent);
        viewContent.hide();
    };

    this.show = function() {
        $content.show();
        manageColumns($content.width(), $content.height());
        header.show();
    };

    this.hide = function() {
        $content.hide();
        header.hide();
        currentViews.forEach(function(view) {
            view.hide();
        });
        currentViews = [];
    };

    this.resize = function(width, height) {
        $content.height(height);
        $content.width(width);

        manageColumns(width, height);
    };
}

module.exports = ColumnLayoutContainer;